<template>
  <div class="product-container">
    <div class="product-details">
      <goback title=""></goback>
      <div class="floorTab">
        <div class="tabs">
          <span class="tab" @click="goFloor(0)" :class="floorNum===0?'sele':''">商品</span>
          <span class="tab" @click="goFloor(1)" :class="floorNum===1?'sele':''">详情</span>
        </div>
      </div>
      <template v-if="currentSku">
        <div class="proudct-imgs floor">
          <img alt v-lazy="currentSku.pic_url" />
          <button
            @click="jumpLink(currentSku.platform_info)"
            class="platform-tips"
            v-if="currentSku.platform_info"
          >
            <span class="tips">{{
              currentSku.platform_info.name
                | brandTips(currentSku.platform_info.brand)
            }}</span>
          </button>
          <!-- 福利金 -->
          <i class="gold_type" :class="skuDetails.gold_type==='福利金'?'red':' '" v-if='Number(skuDetails.gold_status)===1&&skuDetails.gold_type'>可用{{skuDetails.gold_type}}</i>
        </div>
        <div class="proudct-intro van-hairline--top-bottom">
          <div class="price">
            <sku-price :sku="currentSku" :url='contrastUrl' :contrast='contrast'></sku-price>
            <div class="sku-tips">
              <sku-tips :sku="currentSku"></sku-tips>
            </div>
          </div>
          <div class="title">{{ currentSku.name }}</div>
        </div>
        <!-- 服务信息已使用最新设计 -->
        <div class="return-status" v-if="false">
          <div class="status-item">
            <img alt src="../assets/img/goods-details/cert-icon.png" />
            <span>{{ currentSku.sale_tags }}</span>
          </div>
        </div>
        <div class="product-standard" v-if="currentSku.attr_list">
          <a
            @click="checkSku"
            class="product-standard-desc"
            href="javascript:;"
          >
            <div
              class="standard van-ellipsis"
              v-show="currentSku.attr_list.length"
            >
              <span>规格</span>
              <span
                :key="index"
                v-for="(guige, index) in currentSku.attr_list"
                >{{ guige.attr_value.value }}</span
              >
            </div>
            <div class="more"></div>
          </a>
        </div>
        <a
          @click="chooseGoodsAddress"
          class="send-to"
          href="javascript:;"
          v-if="currentSku.item_type === 1"
        >
          <div class="send-to-wrapper">
            <div class="send-address">
              <span>送至</span>
              <img alt src="../assets/img/goods-details/ad-icon.png" />
              <span class="address-details van-ellipsis">
                {{ userQueryInventoryAddressDetails }}
              </span>
            </div>
            <div class="more"></div>
          </div>
          <div class="goods-status" v-if="goodsInventoryTextStatus">
            {{ goodsInventoryText }}
          </div>
        </a>
        <!-- 服务标签 -->
        <section class="service" v-if="currentSku.sale_tags">
          <div class="tags-box">
            <span v-for="(t, i) in parseTags(currentSku.sale_tags)" :key="i">
              {{ t }}
            </span>
          </div>
          <aside>如您对商品和服务有任何问题，请您致电在线客服</aside>
        </section>
        <div class="product-desc-imgs floor">
          <div class="desc-title">
            <h3>商品详情</h3>
          </div>
          <div class="desc-imgs" id="desc" v-if="currentSku">
            <div class="desc-img-intro" v-html="htmlDetails"></div>
          </div>
        </div>
      </template>
      <goods-actions
        :gift-status="skuDetails.is_gift"
        :action-type="actionType"
        :goods-inventory-status="goodsInventoryStatus"
        :txim-userid="skuDetails.txim_userid"
        :vendor-id="skuDetails.vendor_id"
        @free-receive="freeReceive"
        @on-add="addProductHandler"
        @on-buy="buyProductHandler"
        @on-send-gift="onSendGift"
        @openChat="openChat"
      ></goods-actions>
      <SkuChoose
        :goods-inventory-status="goodsInventoryStatus"
        :sku="skuDetails"
        :type="actionType"
        :status="sureStatus"
        @add-cart="onAddCartClicked"
        @buy-clicked="onBuyClicked"
        @close="closeSkuChoose"
        @switch-sku="switchSkuHandler"
        @send-gift="sendGiftHandler"
        v-model="show"
      />

      <dialogs
        @cancel-handler="dialogCancel"
        @confrim-handler="dialogConfrim"
        show-msg
        v-model="dialog.show"
      >
        <template #msg>
          <div>你确定要跳到 {{ dialog.platformName }} 查看原价吗?</div>
        </template>
      </dialogs>
      <dialogs
        @cancel-handler="cancelGetFree"
        @confrim-handler="sureGetFree"
        show-msg
        v-model="getFree.show"
      >
        <template #msg>
          <div class="get-free-desc">
            <p>您确定要领取该商品么?</p>
            <p>(本商品仅限领取一次)</p>
          </div>
        </template>
      </dialogs>
    </div>

    <!-- 地址选择 -->
    <goods-addres-choose
      :show="showAddressChoose"
      @close="closeAddressChoose"
      @switch-address="switchAddress"
      @update="updateAddress"
    ></goods-addres-choose>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import Dialogs from '../components/Dialog'
import Goback from '../components/Goback'
import SkuPrice from '../components/SkuPrice'
import SkuTips from '../components/SkuRewardsTips'
import GoodsActions from '../components/GoodsActions'
import SkuChoose from '../components/SkuChoose'
import GoodsAddresChoose from '../components/goodsDetails/GoodsAddressChoose'
import { wechat } from '../utils/wechat'
let flag = false
let timer = null
export default {
  name: 'product-details',
  components: {
    Goback,
    SkuPrice,
    SkuTips,
    GoodsActions,
    SkuChoose,
    Dialogs,
    GoodsAddresChoose
  },
  props: {
    goodsid: {
      type: [String, Number]
    },
    skuid: {
      type: [String, Number]
    },
    platform: {
      type: String
    }
  },
  data () {
    return {
      floorNum: 0,
      count: 0,
      current: 1,
      show: false,
      sku: {},
      imgList: [],
      skuDetails: {},
      sureStatus: '',
      dialog: {
        show: false,
        platformName: ''
      },
      getFree: {
        show: false
      },
      jumpPlatformName: '',
      jumpPlatforms: ['yanxuan', 'jd', 'suning'],
      htmlHeight: 0,
      htmlDetails: '',
      actionType: -1,
      showAddressChoose: false,
      goodsInventoryTextStatus: false,
      goodsInventoryStatus: true,
      contrast: false,
      contrastUrl: ''
    }
  },
  computed: {
    ...mapState('store', ['currentSkuid', 'currentSku', 'Authorization']),
    ...mapState('goods', ['userQueryInventoryAddress', 'queryInventoryAddress']),
    goodsInventoryText () {
      return this.goodsInventoryStatus ? '有货' : '无货'
    },
    userQueryInventoryAddressDetails () {
      if (this.userQueryInventoryAddress && this.userQueryInventoryAddress.province_code) {
        let street = ''
        if (this.userQueryInventoryAddress.town_name !== 0 && this.userQueryInventoryAddress.town_name !== '0') {
          street = this.userQueryInventoryAddress.town_name
        }
        const detail = this.userQueryInventoryAddress.address_detail ? this.userQueryInventoryAddress.address_detail : ''
        return this.userQueryInventoryAddress.province_name + this.userQueryInventoryAddress.city_name + this.userQueryInventoryAddress.district_name + street + detail
      } else {
        return '选择区域'
      }
    },
    parseTags () {
      return (tags) => {
        return tags.split(',')
      }
    }
  },
  filters: {
    brandTips (name, brand) {
      return name === 'jd' ? '查京东售价' : brand
    }
  },
  watch: {
    async currentSku (newVal) {
      if (newVal) {
        this.htmlDetails = ''
        const status = await this.getHtmlDetails(newVal.sku_id)
        const modules = document.getElementsByClassName('ssd-module')
        const widgetPics = document.getElementsByClassName('ssd-widget-pic')
        const moduleWrap = document.getElementsByClassName('ssd-module-wrap')
        if (status) {
          const links = document.getElementsByClassName('ssd-widget-link')
          if (links.length) {
            Array.from(links).forEach(v => {
              v.parentNode.parentNode.style.display = 'none'
            })
          }
          setTimeout(() => {
            this.setDetailHeight([widgetPics, modules, moduleWrap])
          }, 300)
        }

        // // 更新h5 大字段
        setTimeout(() => {
          this.htmlHeight = document.getElementById('desc') ? document.getElementById('desc').clientHeight : 0
          clearTimeout(timer)
          timer = setTimeout(() => {
            if (this.htmlHeight < 200) {
              this.updateHtml(newVal.sku_id)
            }
          }, 1500)
        }, 1500)
      }
    }
  },
  created () {
    this.$toast.loading('加载中...')
    this.getSkuDetails().then(() => {
      const currentSku = this.skuDetails.sku_list.find(v => v.sku_id === this.skuid - 0)
      this.actionType = (currentSku.activity && currentSku.activity.rule.code) || 0
      console.log(this.actionType)
      this.setCurrentSkuHandler({ currentSku, skuid: this.skuid })
      const skuPrice = (currentSku.activity && currentSku.activity.discount) || (currentSku.equity && currentSku.equity.discount)
      wechat({
        fullPath: this.$route.fullPath,
        name: this.$route.name,
        title: currentSku.name,
        desc: `黑卡PLUS会员专享价: ¥${skuPrice}`,
        imgUrl: currentSku.pic_url
      })

      // 获取用户默认地址以及商品库存查询
      this.updatePlatformAddress(currentSku.platform_info)
      if (currentSku.item_type !== 1) {
        return false
      }
      if (this.userQueryInventoryAddress && this.userQueryInventoryAddress.province_code) {
        this.goodsInventoryInquiry()
      } else {
        this.getUserDefaultAddress().then((data) => {
          if (data) {
            this.goodsInventoryInquiry()
          } else {
            this.goodsInventoryTextStatus = false
          }
        })
      }
    })
    let that = this
    let inner = document.getElementsByClassName('floor')
    window.onscroll = function () {
      let tops = document.documentElement.scrollTop || document.body.scrollTop
      for (let i = 0; i < inner.length; i++) {
        if (inner[i].offsetTop < tops + 200 && tops < inner[i].offsetTop) {
          that.floorNum = i
        }
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    this.setCurrentSkuHandler({ currentSku: null, skuid: -1 })
    next()
  },

  methods: {
    ...mapMutations('goods', ['updatePlatformAddress']),
    ...mapMutations('gift', ['updateConfrimOrderList']),
    ...mapActions('store', ['setCurrentSkuHandler']),
    ...mapActions('goods', ['getQueryInventoryAddress']),

    goFloor (index) {
      this.floorNum = index
      let inner = document.getElementsByClassName('floor')
      window.scrollTo(0, Number(inner[index].offsetTop) - 83)
    },

    chooseGoodsAddress () {
      this.showAddressChoose = true
    },

    closeAddressChoose () {
      this.showAddressChoose = false
    },

    async switchAddress (address) {
      await this.getQueryInventoryAddress({ address, platform: this.currentSku.platform_info })
      this.closeAddressChoose()
      this.goodsInventoryInquiry()
    },

    async updateAddress (address) {
      await this.getQueryInventoryAddress({ address, platform: this.currentSku.platform_info })
      this.closeAddressChoose()
      this.goodsInventoryInquiry()
    },

    /**
     * sku 切换 库存查询
     */
    switchSkuHandler () {
      if (this.userQueryInventoryAddress.province_code && this.currentSku.item_type * 1 === 1) {
        this.$toast.loading('正在查询库存...')
        this.goodsInventoryInquiry().then(() => {
          this.$toast.clear()
        })
      }
    },

    /**
     * 获取默认地址
     */
    async getUserDefaultAddress () {
      const res = await this.$axios.get(`api/address/dar/${this.currentSku.platform}`)
      if (res.status === 200) {
        const { code, data } = res.data
        if (code === 0) {
          this.getQueryInventoryAddress({ address: data, platform: this.currentSku.platform_info })
          return data
        } else {
          this.getQueryInventoryAddress({ address: { id: -1, province_code: 0 }, platform: this.currentSku.platform_info })
          return false
        }
      }
    },

    /**
     * 地址库存查询
     */
    async goodsInventoryInquiry () {
      const res = await this.$axios.post('api/goods/inv', {
        'province_code': this.userQueryInventoryAddress.province_code,
        'city_code': this.userQueryInventoryAddress.city_code,
        'district_code': this.userQueryInventoryAddress.district_code,
        'town_code': this.userQueryInventoryAddress.town_code,
        'platform': this.currentSku.platform,
        'sku_id': this.currentSkuid,
        'sku_name': this.currentSku.name
      })
      if (res.status === 200) {
        const { code } = res.data
        this.goodsInventoryTextStatus = true
        if (code === 0) {
          this.goodsInventoryStatus = true
        } else {
          this.goodsInventoryStatus = false
        }
      }
    },

    dialogCancel () {
      this.dialog.show = false
    },

    dialogConfrim () {
      if (this.jumpPlatforms.includes(this.jumpPlatformName)) {
        location.href = `${process.env.VUE_APP_SKU_LINK}${this.currentSkuid}`
      }
    },

    jumpLink ({ name, title }) {
      this.jumpPlatformName = name
      if (this.jumpPlatforms.includes(name)) {
        this.dialog.platformName = title
        this.dialog.show = true
      }
    },

    onChange (i) {
      this.current = i
    },

    closeSkuChoose () {
      this.show = false
    },

    // 去送礼流程
    onSendGift () {
      if (!this.Authorization) {
        this.$toast('登录后才能加购物车哦!')
        setTimeout(() => {
          this.$router.push({ name: 'login' })
        }, 1500)
        return false
      }
      this.sureStatus = 'gift'
      if (this.currentSku.attr_list) {
        this.show = true
      } else {
        this.sendGiftHandler()
      }
    },

    // 将礼物加入类购物车存储，用于订单页支付
    async sendGiftHandler ({ count }) {
      this.show = false
      const res = await this.$axios.post('api/gift/cart', {
        id: this.currentSkuid,
        num: count || this.currentSku.lowest_buy
      })
      if (res.status === 200) {
        const { code, data } = res.data
        if (code === 0) {
          data.wishes = { ...{ incribe: '请填写落款' }, ...data.wishes }
          data.cart[0].freight = 0
          data.cart[0].wishes = data.wishes
          this.updateConfrimOrderList(data.cart)
          this.$router.push({ name: 'giftEntry' })
        }
      }
    },

    freeReceive () {
      if (this.Authorization) {
        this.getFree.show = true
      } else {
        this.$router.push({ name: 'login' })
      }
    },

    /**
     * 再想想
    */
    cancelGetFree () {
      this.getFree.show = false
    },

    /**
     * 确认领取
    */
    sureGetFree () {
      if (flag) {
        return false
      }
      flag = true
      this.freeReceiveHandler().then(() => {
        flag = false
        this.getFree.show = false
      })
    },

    async freeReceiveHandler () {
      this.$toast.loading('正在领取,请稍候...')
      const res = await this.$axios.post('api/order/rule2', { id: this.currentSkuid })
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg, data } = res.data
        if (code === 0) {
          this.$toast('领取成功')
          this.$router.push({ name: 'orderDetails', query: { orderid: data } })
        } else if (code === -1) {
        } else {
          this.$toast(msg)
        }
      }
    },

    /**
     *立即购买
     */
    async onBuyClicked ({ count }) {
      if (flag) {
        return false
      }
      flag = true
      this.count = count
      await this.createTempOrder()
      flag = false
    },

    /**
     * 多规格加入购物车
     * @param(Number) count sku数量
     */
    async onAddCartClicked ({ count }) {
      if (flag) {
        return false
      }
      flag = true
      this.count = count
      await this.shopingCartHandler()
      flag = false
      this.show = false
    },

    checkSku () {
      if (this.actionType === 2) {
        return false
      }
      this.show = true
      this.sureStatus = 'add'
    },

    /**
     * 加入购物车
     */
    addProductHandler () {
      if (!this.Authorization) {
        this.$toast('登录后才能加购物车哦!')
        setTimeout(() => {
          this.$router.push({ name: 'login' })
        }, 1500)
        return false
      }
      this.sureStatus = 'add'
      if (this.currentSku.attr_list) {
        this.show = true
      } else {
        this.shopingCartHandler()
      }
    },

    /**
     * 立即购买
     */
    buyProductHandler () {
      if (!this.Authorization) {
        this.$toast('登录后才能购买哦!')
        setTimeout(() => {
          this.$router.push({ name: 'login' })
        }, 1500)
        return false
      }
      this.sureStatus = 'buy'
      if (this.currentSku.attr_list) {
        this.show = true
      } else {
        this.createTempOrder()
      }
    },

    /**
     * 创建临时订单
     */
    async createTempOrder () {
      const res = await this.$axios.post('api/order/2.0/sto', {
        type: 'sku',
        sku_id: this.currentSkuid,
        number: this.count || this.currentSku.lowest_buy
      })
      if (res.status === 200) {
        const { code, msg, data } = res.data
        if (code === 0) {
          this.$router.push({ name: 'orderConfirm', query: { oid: data, type: 'sku' } })
        } else {
          this.$toast(msg)
        }
      }
    },

    /**
     * 获取商品详情
     */
    async getSkuDetails () {
      const res = await this.$axios.get(`/api/goods/detail/${this.goodsid}/${this.skuid}`)
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg, data } = res.data
        if (code === 0) {
          this.skuDetails = data
          if (data.contrast && data.contrast.contrast_link && data.contrast.contrast_start && data.contrast.contrast_end) {
            this.contrastUrl = data.contrast.contrast_link
            let now = new Date()
            let start = new Date(data.contrast.contrast_start)
            let end = new Date(data.contrast.contrast_end)
            if (start - now <= 0 && end - now >= 0) {
              this.contrast = true
            }
          }
        } else {
          this.$toast(msg)
        }
      }
    },

    /**
     * 加入购物车
     */
    async shopingCartHandler () {
      const res = await this.$axios.post('/api/cart/2.0/add', {
        id: this.currentSkuid,
        num: this.count || this.currentSku.lowest_buy
      })
      if (res.status === 200) {
        const { code, msg } = res.data
        if (code === 0) {
          this.$toast('加入购物车成功')
          return true
        } else if (code === -1) {
          return false
        } else {
          this.$toast(msg)
          return false
        }
      }
    },

    /**
     * 设置h5大字段图片高度
     */
    setDetailHeight (els) {
      els.forEach(v => {
        // console.log(v)
        for (let i = 0; i < v.length; i++) {
          // console.log(v[i].classList, v[i].className)
          if (
            (v[i].classList.length > 0 &&
              [...v[i].classList].includes('ssd-module-heading')) ||
            (v[i].classList.length === 1 &&
              [...v[i].classList].includes('ssd-module-wrap'))
          ) {
            continue
          } else {
            if (v[i].clientHeight) {
              v[i].style.height = v[i].clientHeight / 100 + 'rem'
            }
          }
        }
      })
    },

    /**
     * 获取h5大字段
    */
    async getHtmlDetails (skuid) {
      const res = await this.$axios.get(`${skuid}/intro.html`, { baseURL: process.env.VUE_APP_HTML_URL })
      if (res.status === 200) {
        this.htmlDetails = res.data
        return true
      }
    },

    /**
     * 更新h5 大字段
    */
    async updateHtml () {
      await this.$axios.post('api/sys/h5-refresh', { sku_id: this.currentSkuid })
    },
    openChat () {
      const data = {
        ...this.skuDetails,
        productUrl: location.href
      }
      this.$store.commit('chat/updateProductInfo', data)
    }
  }

}
</script>
<style scoped>
.desc-imgs {
  width: 7.5rem;
  padding-bottom: 0.2rem;
  font-size: 0.28rem;
  word-break: break-all;
}
.desc-imgs >>> img {
  width: 100% !important;
  height: auto;
}
.desc-imgs .desc-img-intro >>> div {
  max-width: -webkit-fill-available !important;
  font-size: 0.34rem !important;
}
.desc-imgs .desc-img-intro >>> .ssd-widget-pic {
  max-width: unset !important;
  font-size: 0.2rem !important;
}
.desc-imgs .desc-img-intro >>> .ssd-module-mobile-wrap .ssd-widget-text,
.desc-imgs .desc-img-intro >>> .ssd-module-wrap .ssd-widget-text {
  font-size: 0.2rem !important;
  line-height: 1.1;
}

.desc-imgs >>> p {
  max-width: 7.5rem;
}
.desc-imgs >>> p img {
  width: 100%;
  vertical-align: top;
}
.desc-imgs >>> .ssd-module-wrap,
.desc-imgs .desc-img-intro >>> .ssd-module-mobile-wrap {
  width: 100% !important;
}

.desc-imgs .desc-img-intro >>> .ssd-module-heading-layout span {
  font-size: 0.2rem !important;
  line-height: none;
}

.desc-imgs >>> .ssd-good-name {
  font-size: 0.2rem !important;
}
.desc-img .desc-img-intro >>> .ssd-widget-text {
  font-size: 0.34rem !important;
  color: red;
}
.desc-imgs >>> table {
  width: 7.5rem !important;
  height: 100%;
  display: block;
}
.desc-imgs .desc-img-intro >>> table td,
.desc-imgs .desc-img-intro >>> table tbody,
.desc-imgs .desc-img-intro >>> table tr {
  display: block;
  width: 100%;
  height: 100%;
}

.desc-imgs >>> div[align="center"] div {
  width: 7.5rem !important;
}
.desc-imgs >>> #ssd-vc-goods,
.desc-imgs >>> .ssd-module-goods,
.desc-imgs >>> .ssd-module-heading {
  display: none;
}
</style>
<style lang="less" scoped>
.product-details {
  padding-top: 1.65rem;
  padding-bottom: 0.9rem;
  background-color: #fff;
  .floorTab{
    background: #fff;
    position: fixed;
    top:1rem;
    left:50%;
    transform: translateX(-50%);
    width: 100%;
    height: .65rem;
    z-index: 99;
  }
  .tabs{
    width: 2.6rem;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    span{
      font-size: .32rem;
    }
    .sele{
      position: relative;
      color: #e3b870;
    }
    .sele::after{
      position: absolute;
      left: -0.09rem;
      bottom: -0.1rem;
      content:'';
      width: 0.8rem;
      height: 0.03rem;
      background: #e3b870;
    }
  }
  .proudct-imgs {
    width: 100%;
    position: relative;
    .platform-tips {
      position: absolute;
      bottom: 0rem;
      left: 0.3rem;
      background-size: 100%;
      display: flex;
      .tips {
        position: relative;
        padding-left: 0.45rem;
        padding-right: 0.1rem;
        height: 0.35rem;
        font-size: @fz24;
        color: #ff2828;
        border: 0.5px solid #ff2828;
        background-color: #fff;
        &::before {
          position: absolute;
          left: 0;
          content: "";
          width: 0.35rem;
          height: 0.35rem;
          background: url("../assets/img/z-icon.png") center no-repeat #ff2828;
          background-size: 0.3rem;
        }
      }
    }
    .gold_type{
      position: absolute;
      bottom: 0rem;
      left: 2.3rem;
      background-size: 100%;
      font-size: .22rem;
      color: #fff;
      padding: .04rem .15rem;
      background: #3cd407;
    }
    .red{
      background: #FF3824;
    }
    .swiper {
      height: 5.96rem;
      padding-bottom: 0.76rem;
      .custom-indicator {
        position: absolute;
        bottom: 0.35rem;
        left: 0.3rem;
        right: 0.3rem;
        .flex-between;
        .num {
          right: 0.3rem;
          width: 0.66rem;
          height: 0.34rem;
          .flex-center;
          border: 0.5px solid @c97;
          border-radius: 30px;
          color: @c97;
          font-size: @fz18;
        }
      }
    }
    .icon {
      width: 1.33rem;
      height: 0.35rem;
    }
  }
  .proudct-intro {
    padding: 0.2rem;
    .price {
      padding-bottom: 0.25rem;
      .flex-between;
      .sku-price {
        font-size: @fz22;
        color: @base;
        span {
          color: @price;
          font-size: @fz20;
          em {
            font-size: @fz32;
            font-weight: 660;
          }
        }
        del {
          color: @del;
          padding-left: 0.3rem;
        }
      }
    }
    .title {
      font-size: @fz28;
      color: @base;
      font-weight: 660;
      .ellipsis4;
    }
  }
  .product-platform-save {
    padding: 0 0.2rem;
    height: 0.5rem;
    display: flex;
    align-items: center;
    ul {
      display: flex;
      font-size: @fz18;
      li {
        padding-right: 0.26rem;
      }
    }
    img {
      width: 0.3rem;
    }
  }
  .return-status {
    height: 0.5rem;
    display: flex;
    align-items: center;

    .status-item {
      font-size: @fz22;
      padding-left: 0.25rem;
      color: @c80;
      display: flex;
      align-items: center;
      img {
        width: 0.2rem;
        height: 0.25rem;
        object-fit: contain;
        padding-right: 0.1rem;
      }
    }
  }
  .product-standard,
  .send-to {
    padding: 0 0.2rem;
    .more {
      width: 0.48rem;
      height: 0.48rem;
      background: url("../assets/img/more.png") center no-repeat;
      background-size: 100%;
    }
  }
  .product-standard {
    border-top: 0.2rem solid #f6f6f6;
    border-bottom: 0.2rem solid #f6f6f6;
    a.product-standard-desc {
      .flex-between;
      height: 0.78rem;
      font-size: @fz24;
      color: @base;
      .standard {
        span:nth-child(2) {
          font-size: fz22;
          padding-left: 0.48rem;
        }
      }
    }
  }

  .send-to {
    border-bottom: 0.2rem solid #f6f6f6;
    font-size: @fz24;
    color: @base;
    display: flex;
    justify-content: center;
    flex-direction: column;
    .send-to-wrapper {
      .flex-between;
      height: 0.78rem;
    }
    .send-address {
      display: flex;
      align-items: center;
      img {
        width: 0.2rem;
        height: 0.24rem;
        padding-left: 0.4rem;
        padding-right: 0.2rem;
      }
      .address-details {
        display: inline-block;
        width: 5.2rem;
      }
    }
    .goods-status {
      padding-left: 0.9rem;
      color: #ff5d5d;
      padding-bottom: 0.2rem;
    }
    .no-nventory {
      color: #ccc;
    }
  }
  .service {
    border-bottom: 0.2rem solid #f6f6f6;
    padding: 0.2rem 0.32rem 0.24rem;

    aside {
      font-size: 0.26rem;
      color: #a8aab4;
      margin-top: 0.23rem;
    }
    .tags-box {
      line-height: 0.3rem;

      span {
        font-size: 0.26rem;
        color: #424242;
        background: url("../assets/img/baozhang.png") no-repeat;
        background-size: 0.29rem 0.32rem;
        padding-left: 0.42rem;
        margin-right: 0.2rem;
      }
    }
  }
  .product-desc-imgs {
    .safe-area-inset-bottom;
    .desc-title {
      padding: 0.22rem 0.2rem;
      h3 {
        font-size: @fz26;
        color: @base;
        padding-left: 0.2rem;
        border-left: 0.1rem solid #ff3824;
      }
    }
  }
  .get-free-desc {
    p:nth-child(2) {
      padding-top: 0.15rem;
    }
  }
}
</style>
